
import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class Contract extends BaseEntity {
  
  contractCode      : string  = "xxxx";
  startDate         : Date    = new Date();
  endDate           : Date    = new Date();
  hold              : boolean = false;
  holdReason        : string  = "xxxx"
  
  constructor() {
   super()
  }
  
}
